import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

type RouterLocation = ReturnType<typeof useLocation>;

const LastLocationContext = createContext<RouterLocation | null>(null);

export function LastLocationProvider({ children }: { children: React.ReactNode }) {
    const location = useLocation();
    const currentRef = useRef<RouterLocation>(location);
    const [lastLocation, setLastLocation] = useState<RouterLocation | null>(null);

    useEffect(() => {
        if (currentRef.current.pathname !== location.pathname) {
            setLastLocation(currentRef.current);
        }
        currentRef.current = location;
    }, [location]);

    return <LastLocationContext.Provider value={lastLocation}>{children}</LastLocationContext.Provider>;
}

export function useLastLocation(): RouterLocation | null {
    return useContext(LastLocationContext);
}
